<app-spinner />
<p>Retrieving user information ...</p>
